import React from 'react'
import TopMenuMobileWrapper from './TopMenuMobileWrapper'
import TopMenuMobileUI from './TopMenuMobileUI'

const TopMenuMobile = () => {
	return <TopMenuMobileWrapper />
}

export default TopMenuMobile
